import { render } from "./SkuTaskDetail.vue?vue&type=template&id=92de30c6&scoped=true&ts=true"
import script from "./SkuTaskDetail.vue?vue&type=script&lang=ts"
export * from "./SkuTaskDetail.vue?vue&type=script&lang=ts"

import "./SkuTaskDetail.vue?vue&type=style&index=0&id=92de30c6&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92de30c6"]])

export default __exports__